"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ScheduleReportFormContainer = _interopRequireDefault(require("./ScheduleReportForm/ScheduleReportFormContainer"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('schedule-report');
var ScheduleReportComponent = function ScheduleReportComponent() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_ScheduleReportFormContainer["default"], null));
};
var _default = exports["default"] = ScheduleReportComponent;